// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"SubscriptionPage_mainContainer__3nFKe"};